export default "__VITE_ASSET__lnzZX9Y1__"